import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import useCashbackProgram from '../../hooks/cashback/useCashbackProgram';
import useAuth from '../../hooks/global/useAuth';
import useMobileApp from '../../hooks/mobile-app/useMobileApp';
import useAppMethods from '../../hooks/utility/useAppMethods';
import useModalRouter from '../../modules/mobile/common/hooks/useModalRouter';
import { Modals } from '../../modules/mobile/exports/Enums';
import useInitialData from '../../hooks/global/useInitialData';

const useMobileAppSignupBonus = (className: string) => {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Carousel:DealsCarousel' });
  const { cashbackProgram, account } = useCashbackProgram();
  const { isLoggedIn } = useAuth();
  const { isMobileApp } = useMobileApp();
  const { toggleMobileAppSignupBonusModal, formatCurrency } = useAppMethods();
  const { openModal } = useModalRouter();
  const { data } = useInitialData();
  const requiredData = [
    cashbackProgram?.mobile_app_signup_bonus,
    data?.franchise?.mobile_app?.app_bundle_identifier,
    data?.franchise?.mobile_app?.uuid,
    data?.franchise?.mobile_app?.asc_app_id,
    data?.franchise?.mobile_app?.released,
  ];

  if (!requiredData.every(Boolean)) {
    return;
  }

  if (isLoggedIn && isMobileApp) {
    return;
  }

  if (isLoggedIn && account?.has_mobile_app_signup_bonus) {
    return;
  }

  const bonusAmount = formatCurrency(cashbackProgram.mobile_app_signup_bonus / 100);
  const onClick = () => {
    if (isMobileApp) {
      openModal({
        id: Modals.Login,
      });
      return;
    }

    toggleMobileAppSignupBonusModal({ openModal: true });
  };

  return {
    data: cashbackProgram.mobile_app_signup_bonus,
    render: () => ({
      key: 'mobile_app_signup_bonus',
      title: t('deals.mobile_app_signup_bonus.title', { amount: bonusAmount }),
      description: t('deals.mobile_app_signup_bonus.desc', { amount: bonusAmount }),
      className: classnames(className, 'cursor-pointer'),
      footer: t('deals.buttons.show_details'),
      onClick,
    }),
  };
};

export default useMobileAppSignupBonus;
